<div class="content">
  <div class="circle">
    <span >{{ data.number }}</span>
  </div>
  <img width="130" height="130" [src]="data.imageUrl" alt="imagem">
  <span class="title" [innerHTML]="data.title">

  </span>
  <span class="description" [innerHTML]="data.description">
  </span>
</div>
